import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import Modal from '../common/Modal/Modal';
import ScallopWeight from '../ScallopTables/ScallopWeight';
import '../common/SliderControls/SliderControls.css';

/**
 * BAS (Best Available Science) Scallop Weight - button to open the
 * Scallop Shell Height to Weight analysis modal.
 */
export default function BasScallopWeight(
  _props: RegistryComponentProps
): React.ReactElement {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => {
    setShowModal(false);
    document.body.style.overflow = 'auto';
  };

  return (
    <>
      <div
        className="ai-insights clickable"
        onClick={() => setShowModal(true)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setShowModal(true);
          }
        }}
        role="button"
        tabIndex={0}
        aria-label="Explore insights from best available science for scallop shell height to weight"
      >
        <div className="ai-insights-label">Insights from best available science</div>
        <div className="ai-insights-text">
          Explore how scallop shell height to weight relationships have evolved over time across different management areas.
        </div>
        <div className="ai-insights-click-hint">Click to explore detailed research</div>
      </div>

      {showModal &&
        createPortal(
          <Modal
            title="BAS Analysis - Scallop Shell Height to Weight"
            onClose={handleClose}
            size="extra-large"
            transparentBackdrop={true}
            parameterStyle={true}
            {...({ customMaxWidth: '90vw', customMaxHeight: '90vh' } as Record<string, unknown>)}
            headerStyle={{
              marginBottom: '20px',
              paddingBottom: '10px',
              borderBottom: '1px solid #e5e7eb',
            }}
            bodyStyle={{ padding: '20px', overflow: 'auto' }}
          >
            <div
              style={{
                marginBottom: '15px',
                padding: '10px',
                background: '#f0f9ff',
                borderRadius: '6px',
                border: '1px solid #bae6fd',
              }}
            >
              <p style={{ margin: 0, fontSize: '14px', color: '#0369a1' }}>
                <strong>💡 Info:</strong> This chart shows how scallop shell height to weight relationships have evolved over time across different management areas.
              </p>
            </div>
            <ScallopWeight />
          </Modal>,
          document.body
        )}
    </>
  );
}
